module.exports = __webpack_public_path__ + "img/Privacy.cffa6f48.png";